import { css } from '@emotion/react'
import compact from 'lodash/compact'

type Child =
  | React.ReactElement<typeof Grid.Row>
  | React.ReactElement<typeof Grid.Col>
  | false
  | undefined
  | null

/**
 * @deprecated use `<Spacer>` instead
 */
export default function Grid(
  props: {
    spacing: 0 | 5 | 10 | 15 | 20 | 30 | 40
    children: Child | Array<Child>
  } & Omit<React.HTMLAttributes<HTMLDivElement>, 'children'>,
) {
  const { spacing, ...rest } = props

  const nodeList = compact(Array.isArray(props.children) ? props.children : [props.children])
  const verticalAligned = nodeList.some((node) => node.type === Grid.Row)

  return (
    <div
      css={[
        css`
          display: flex;
        `,
        verticalAligned
          ? css`
              flex-direction: column;
              > * {
                margin-top: ${spacing}px;
                &:first-of-type {
                  margin-top: 0;
                }
              }
            `
          : css`
              flex-direction: row;
              > * {
                margin-left: ${spacing}px;
                &:first-of-type {
                  margin-left: 0;
                }
              }
            `,
      ]}
      {...rest}
    />
  )
}

Grid.Row = function GridRow(
  props: {
    height?: string | number
    flex?: string | number | boolean
  } & React.HTMLAttributes<HTMLDivElement>,
) {
  const { height, flex, style, ...rest } = props

  return (
    <div
      {...rest}
      css={css`
        :empty + * {
          margin-top: 0;
        }
      `}
      style={{
        ...style,
        height: typeof height === 'number' ? height + 'px' : height,
        flex: getFlex(flex),
      }}
    />
  )
}

Grid.Col = function GridCol(
  props: {
    width?: string | number
    flex?: string | number | boolean
  } & React.HTMLAttributes<HTMLDivElement>,
) {
  const { width, flex, style, ...rest } = props

  return (
    <div
      {...rest}
      css={css`
        :empty + * {
          margin-left: 0;
        }
      `}
      style={{
        ...style,
        width: typeof width === 'number' ? width + 'px' : width,
        flex: getFlex(flex),
      }}
    />
  )
}

function getFlex(flex: string | number | boolean | undefined) {
  if (typeof flex === 'boolean') {
    return flex ? 1 : 0
  }
  return flex
}
